export enum PermissionObjectIds {
    PERMISSION_MANAGEMENT = 0,
    QUOTATION = 1,
    PURCHASE_ORDER = 2,
    INVOICE = 3,
    BANK = 4,
    BANK_ACCOUNT = 5,
    EXCHANGE_RATE = 6,
    ACCOUNT_STATEMENT_RECORD = 7,
    ACCOUNT_STATEMENT_LIST = 8,
    ACCOUNT_STATEMENT = 9,
    REPORT_SALES_PO = 10,
    REPORT_SALES_SUMMARY = 11,
    CUSTOMER = 12,
    PRODUCT = 13,
    PRODUCT_MANAGEMENT = 14,
    PRODUCT_PACKAGE = 15,
    END_USER_LIST = 16,
    DELIVERY_METHOD = 17,
    PAYMENT_TERM = 18,
    PRINT_ENVELOP = 19,
    FILING_RECORD_PO = 20,
    CHANGE_PASSWORD = 21,
    STAFF_MANAGEMENT = 22,
    REPORT_SALES_ANALYSIS = 23,
    ACCOUNT_SYSTEM = 24,
    BRANCH_SETUP = 25,
    ACCOUNT_MASTER_SETUP = 26,
    ACCOUNT_DAILY_OPERATION = 27,
    ADMINISTRATION = 28,
    STAFF_PERMISSION_MANAGEMENT = 29,
    DUMMY_30 = 30,
    DUMMY_31 = 31,
    DUMMY_32 = 32,
    DUMMY_33 = 33,
    DUMMY_34 = 34,
    TRADING_REPORT = 35,
    USER_ACTION_LOG = 36,
    TRADING_SALES_HISTORY = 37,
    TRADING_QUOTATION_HISTORY = 38,
    SUPPLIER = 39,
    PRODUCT_ENQUIRY = 40,
    FILING_RECORD_INVOICE = 41,
    PO_ENQUIRY = 42,
    INVENTORY_REPORT = 43,
    DUMMY_44 = 44,
    DUMMY_45 = 45,
    PURCHASE_RANKING = 46,
    PACKING_LIST = 47,
    BOX_SIZE = 48,
    MANUFACTURER = 49,
};

export enum PermissionObjectNames {
    PERMISSION_MANAGEMENT = "Permission Management",
    QUOTATION = "Quotation",
    PURCHASE_ORDER = "Purchase Order",
    INVOICE = "Invoice",
    BANK = "Bank",
    BANK_ACCOUNT = "Bank Account",
    EXCHANGE_RATE = "Exchange Rate",
    ACCOUNT_STATEMENT_RECORD = "Statement Record",
    ACCOUNT_STATEMENT_LIST = "Account Statement List",
    ACCOUNT_STATEMENT = "Statement",
    REPORT_SALES_PO = "Sales PO Report",
    REPORT_SALES_SUMMARY = "Sales Summary Report",
    CUSTOMER = "Customer Management",
    PRODUCT = "Product",
    PRODUCT_MANAGEMENT = "Product Management",
    PRODUCT_PACKAGE = "Product Package",
    END_USER_LIST = "End User Management",
    DELIVERY_METHOD = "Delivery Method",
    PAYMENT_TERM = "Payment Term",
    PRINT_ENVELOP = "Print Envelop",
    FILING_RECORDING_PO = "PO Filing Record",
    CHANGE_PASSWORD = "Change Password",
    STAFF_MANAGEMENT = "Staff Management",
    REPORT_SALES_ANALYSIS = "Sales Analysis Report",
    ACCOUNT_SYSTEM = "Account System",
    BRANCH_SETUP = "Branch Management",
    ACCOUNT_MASTER_SETUP = "Account Master Setup",
    ACCOUNT_DAILY_OPERATION = "Account Daily Operation",
    ADMINISTRATION = "Administration",
    STAFF_PERMISSION_MANAGEMENT = "Staff Permission",
    DUMMY_30 = "Dummy",
    DUMMY_31 = "Dummy",
    DUMMY_32 = "Dummy",
    DUMMY_33 = "Dummy",
    DUMMY_34 = "Dummy",
    TRADING_REPORT = "Trading Reports",
    USER_ACTION_LOG = "User Action Log",
    TRADING_SALES_HISTORY = "Sales History",
    TRADING_QUOTATION_HISTORY = "Quotaiton History",
    SUPPLIER = "Supplier",
    PRODUCT_ENQUIRY = "Product Enquiry",
    FILING_RECORD_INVOICE = "Invoice Filing Record",
    PO_ENQUIRY = "PO Enquiry",
    INVENTORY_REPORT = "Inventory Report",
    DUMMY_44 = "Dummy",
    DUMMY_45 = "Dummy",
    PURCHASE_RANKING = "Purchase Ranking",
    PACKING_LIST = "Packing List",
    BOX_SIZE = "Box Size",
    MANUFACTURER = "Manufacturer"
};

export function getPermissionObjectNameById(permissionId: PermissionObjectIds)
{
    return Object.values(PermissionObjectNames)[permissionId];
}